"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "fetchCustomers", {
    enumerable: true,
    get: ()=>fetchCustomers
});
const _graphqlRequest = require("graphql-request");
const _customerFragment = require("../fragments/customer-fragment");
const fetchCustomers = (0, _graphqlRequest.gql)`
  query customers(
    $retailerId: ID!,
    $filters: CustomersFilter,
  ){
    customers(
      retailerId: $retailerId
      filter: $filters
    ) {
        ...customerFragment
    }
  }
  ${_customerFragment.CUSTOMER_FRAGMENT}
`;
